var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"agreement"}},[_c('div',[_c('el-dialog',{attrs:{"visible":_vm.Show,"width":"50%"},on:{"update:visible":function($event){_vm.Show=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tcpData.content)}})])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2d6ef4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tcp.vue
// module id = null
// module chunks = 